import React from 'react';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import EmailIcon from '@material-ui/icons/Email';
import RoomIcon from '@material-ui/icons/Room';
import { Button, Col, Form, Row} from 'react-bootstrap';
import GoogleMaps from './maps/GoogleMaps';

const Contact = () =>{
    return (
        <React.Fragment>
            <section className="py-5 mt-3 contact-section"></section>
                <section className="contact">
                    <div className="dark">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <h2 className="text-uppercase pt-sm-5">contact info</h2>
                                    <p className="lead">Please make an appointment before any meeting</p>
                                    <hr/>
                                    <div className="row">
                                        <div className="col-12 col-md-12">
                                        <h4 className="ml-5">For any Query or Appointment:</h4>
                                            <h5><PhoneEnabledIcon className="mr-4" />+8801765-251201 (WhatsApp)</h5>
                                            <h5><PhoneEnabledIcon className="mr-4" />+8801511-325168</h5>
                                            <h5><EmailIcon className="mr-4" />maseerinsinfo@gmail.com</h5>
                                        </div>

                                        {/* <div className="col-12 col-md-6">
                                        <h4><EmailIcon className="mr-4" />Help Line</h4>
                                        <h5 className="ml-5">maseerinsinfo@gmail.com</h5>
                                        </div> */}
                                    </div>
                                    <hr/>
                                    <h4><RoomIcon className="mr-4" />Address</h4>
                                    <p className="lead ml-5">House# 116, Senpara-parbota, Mirpur 10, Dhaka-1216. Bangladesh</p>
                                    {/* <hr/> */}
                                </div>
                                <div className="col-12 col-lg-6">
                                    <h2 className="text-uppercase pt-sm-5">send a message</h2>
                                    <p className="lead">Your email address will be secured with US</p>
                                    <hr/>
                                    <div className="contact-section">
                                        <div className="row">
                                        <Form action="https://formspree.io/f/mjvjadpv" method="POST">
                                            <Form.Group as={Row} controlId="formPlaintextPassword">
                                                <Col md="6" sm="12 pb-3">
                                                    <Form.Control type="text" name="Name" placeholder="Name *" required />
                                                </Col>
                                                <Col md="6" sm="12">
                                                    <Form.Control type="text" name="Email" placeholder="Email *" required />
                                                </Col>
                                                <Col md="12">
                                                    <Form.Control type="text" name="Subject" className="my-3" placeholder="Subject *" required />
                                                </Col>
                                                <Form.Group controlId="exampleForm">
                                                    <Form.Control as="textarea" name="Message" Rows={5} placeholder="Message *" required />
                                                    </Form.Group>
                                                </Form.Group>
                                                <Button variant="primary" className="my-2" type="submit">Submit</Button>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        </div>
                    </div>
                </section>
            <GoogleMaps />
        </React.Fragment>
    )
}
export default Contact;